import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Serials from './pages/Serials';
import Fingerprints from './pages/Fingerprints';
import Customers from './pages/Customers';
import Activate from './pages/Activate';
import Settings from './pages/Settings';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';

function App() {
  const isClientMode = window.location.pathname.startsWith('/activate');
  
  return (
    <AuthProvider>
      <Router basename={isClientMode ? '/activate' : '/license'}>
        <Routes>
          {isClientMode ? (
            // 客户模式：/activate 下只显示客户登录
            <>
              <Route path="/" element={<Activate />} />
              <Route path="/login" element={<Activate />} />
            </>
          ) : (
            // 管理员模式：/license 下显示完整后台
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/activate" element={<Activate />} />
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="serials" element={<Serials />} />
                <Route path="fingerprints" element={<Fingerprints />} />
                <Route path="customers" element={<Customers />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </>
          )}
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
